import { useEffect } from 'react';

interface UseTrialTimerOptions {
  trialEndDate?: string;
  isInTrial?: boolean;
  onTrialExpired: () => void;
}

export function useTrialTimer({
  trialEndDate,
  isInTrial: isInTrial,
  onTrialExpired,
}: UseTrialTimerOptions) {
  useEffect(() => {
    if (!trialEndDate || !isInTrial) return;

    const endDate = new Date(trialEndDate);
    const now = new Date();

    if (endDate <= now) {
      onTrialExpired();
      return;
    }

    const timeUntilExpiration = endDate.getTime() - now.getTime();
    const timerId = setTimeout(() => {
      onTrialExpired();
    }, timeUntilExpiration);

    return () => clearTimeout(timerId);
  }, [isInTrial, trialEndDate, onTrialExpired]);
}
